import { useDispatch, useSelector } from 'react-redux';
import { SectionBlock } from '../components';
import { Switch } from '@material-ui/core';
import styled from 'styled-components';
import { useEditNotificationsSettingsMutation } from 'services/api';
import { Field, Form, FormSpy } from 'react-final-form';
import { useMemo } from 'react';
import { openAllowSmsDialog } from '../../../../services/userSlice/userSlice';

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0px 8px;
`;

const SwitchComponent = styled.div`
  display: flex;
  color: #757575;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
  flex: 1 1 40%;

  & > span {
    min-width: fit-content;
  }
`;

export const NotificationSettings = () => {
  const user = useSelector(state => state.user?.user);
  const [updateNotificationSettings, { isLoading }] = useEditNotificationsSettingsMutation();

  const dispatch = useDispatch();
  const openSmsDialog = () => dispatch(openAllowSmsDialog());

  const initialValues = useMemo(
    () => ({
      visualNotificationsEnabled: user?.visual_notifications_enabled,
      audioNotificationsEnabled: user?.audio_notifications_enabled,
      smsNotificationsEnabled: user?.sms_notifications_enabled
    }),
    [user?.audio_notifications_enabled, user?.visual_notifications_enabled, user?.sms_notifications_enabled]
  );

  if (!user) return null;

  const renderCheckbox = ({ input, meta }) => {
    console.log(input, meta, 'input, meta');
    const onChange = e => {
      if (input.name === 'smsNotificationsEnabled' && !user.sms_notifications_allowed) {
        openSmsDialog();
        return;
      }

      input.onChange(e);
    };
    return <Switch color="primary" {...input} onChange={onChange} />;
  };

  const submitForm = async values => {
    if (isLoading) return;
    try {
      await updateNotificationSettings({
        userId: user.id,
        audioNotificationsEnabled: values.audioNotificationsEnabled,
        visualNotificationsEnabled: values.visualNotificationsEnabled,
        smsNotificationsEnabled: values.smsNotificationsEnabled
      });
    } catch (error) {
      console.error('Cant submit form', error);
    }
  };

  return (
    <Form onSubmit={submitForm} initialValues={initialValues}>
      {({ form }) => (
        <SectionBlock title="Notifications" isEditable={true} showControlButtons={false} submit={() => {}}>
          <ContentWrapper>
            <SwitchComponent>
              <span>Visual notifications</span>
              <Field name="visualNotificationsEnabled" type="checkbox" render={renderCheckbox} />
            </SwitchComponent>
            <SwitchComponent>
              <span>Audio notifications</span>
              <Field name="audioNotificationsEnabled" type="checkbox" render={renderCheckbox} />
            </SwitchComponent>
            <SwitchComponent>
              <span>SMS notifications</span>
              <Field name="smsNotificationsEnabled" type="checkbox" render={renderCheckbox} />
            </SwitchComponent>
          </ContentWrapper>
          <FormSpy
            subscription={{ values: true }}
            onChange={async ({ values }) => {
              try {
                // if (values.smsNotificationsEnabled && !user.sms_notifications_allowed) {
                //   openSmsDialog();
                // } else {
                //   await form.submit();
                // }
                await form.submit();
              } catch (e) {
                console.error(e);
              }
            }}
          />
          {/* <AllowSmsDialog
            onClose={() => {
              form.change('smsNotificationsEnabled', false);
            }}
          /> */}
        </SectionBlock>
      )}
    </Form>
  );
};
